import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import StoryFrame from './StoryFrame'
import Map from './Map'

import { loadExhibit, selectExhibit, selectMapStyleName } from './features/exhibitReducer'
import { loadOrganization } from './features/organizationReducer'
import { loadStories, initStoriesPager } from './features/storiesReducer'
import { loadPins } from './features/pinsReducer'
import { loadStyle, setZoom, setCenter } from './features/mapReducer'

function MapExhibit(props) {
  const dispatch = useDispatch()
  const exhibitId = props.match.params.exhibitId

  const exhibit = useSelector(selectExhibit)
  const orgId = exhibit.orgId
  const zoom = exhibit.mapZoom
  const center = exhibit.mapCenterAddressCoords

  const styleName = useSelector(selectMapStyleName)

  useEffect(() => {
    dispatch(loadExhibit(exhibitId))
    dispatch(initStoriesPager(exhibitId))
  }, [dispatch, exhibitId])

  useEffect(() => {
    dispatch(loadOrganization(orgId))
  }, [dispatch, orgId])

  useEffect(() => {
    dispatch(setCenter(center))
    dispatch(setZoom(zoom))
  }, [dispatch, zoom, center])

  useEffect(() => {
    dispatch(loadStories())
  }, [dispatch])

  useEffect(() => {
    dispatch(loadPins({exhibitId, styleName}))
    dispatch(loadStyle(styleName))
  }, [dispatch, styleName])

  return (
    <div data-testid="exhibit-element" >
      <StoryFrame />
      <Map />
    </div>
  )
}

export default MapExhibit
